var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_vm._t("top"),_c('v-autocomplete',_vm._g(_vm._b({attrs:{"width":"90px","dense":"","hide-details":"","clearable":_setup.nullable,"items":[
            { value: true, label: _vm.$t('yes') },
            { value: false, label: _vm.$t('no') },
        ],"item-text":"label","item-value":"value","value":_vm.$attrs.value ?? (_setup.nullable ? null : false)}},'v-autocomplete',_vm.$attrs,false),_vm.$listeners))],2)
}
var staticRenderFns = []

export { render, staticRenderFns }